import { lAsync } from 'app/blocks/common/codes';
import { confirm, confirmType } from 'app/blocks/Modal/utils';
import ConfirmChangeToSubscriptionModal from './ConfirmChangeToSubscriptionModal';
import ConfirmNIHSubscriptionModal from './ConfirmNIHSubscriptionModal';

async function confirmSubscriptionSelection() {
    return confirm(await lAsync('LICENSE_SIGNING.OPEN_ACCESS.CONFIRM_SUBSCRIPTION_POPUP.TEXT'));
}

async function confirmNIHSubscriptionSelection() {
    return confirmType(ConfirmNIHSubscriptionModal);
}

function confirmChangeFromOnlineOpenToSubscription() {
    return confirmType(ConfirmChangeToSubscriptionModal);
}

export { confirmChangeFromOnlineOpenToSubscription, confirmNIHSubscriptionSelection, confirmSubscriptionSelection };
